import { ArrowRight } from "lucide-react";
import { useState } from "react";

import api, { formatApiError } from "../lib/api";

const initialForm = { name: "", phone: "", email: "", registration_number: "", message: "" };

export default function SellForm({ copy }) {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [sending, setSending] = useState(false);

  const update = (event) => setForm({ ...form, [event.target.name]: event.target.value });

  const submit = async (event) => {
    event.preventDefault();
    setSending(true);
    setStatus({ type: "", message: "" });
    try {
      const { data } = await api.post("/public/inquiries", form);
      setForm(initialForm);
      setStatus({ type: "success", message: copy.form_success_message });
    } catch (error) {
      setStatus({ type: "error", message: copy.form_error_message || formatApiError(error) });
    } finally {
      setSending(false);
    }
  };

  return (
    <form className="sell-form" data-testid="sell-car-form" onSubmit={submit}>
      <div className="form-grid">
        <label>{copy.form_name_label}<input required data-testid="sell-form-name-input" name="name" value={form.name} onChange={update} /></label>
        <label>{copy.form_phone_label}<input required data-testid="sell-form-phone-input" name="phone" type="tel" value={form.phone} onChange={update} /></label>
        <label>{copy.form_email_label}<input required data-testid="sell-form-email-input" name="email" type="email" value={form.email} onChange={update} /></label>
        <label>{copy.form_registration_label}<input required data-testid="sell-form-registration-input" name="registration_number" value={form.registration_number} onChange={update} /></label>
      </div>
      <label>{copy.form_message_label}<textarea required data-testid="sell-form-message-input" name="message" placeholder={copy.form_message_placeholder} rows="4" value={form.message} onChange={update} /></label>
      <input aria-hidden="true" autoComplete="off" className="form-honeypot" data-testid="sell-form-website-input" name="website" tabIndex="-1" value={form.website || ""} onChange={update} />
      {status.message && <p className={`form-status form-status--${status.type}`} data-testid="sell-form-status">{status.message}</p>}
      <button className="text-button" data-testid="sell-form-submit-button" disabled={sending} type="submit">{sending ? copy.form_sending_label : copy.form_submit_label}<ArrowRight size={18} /></button>
    </form>
  );
}